import { lazy } from 'react';
const Home = lazy(() => import('@/pages/home'));
const Result = lazy(() => import('@/pages/result/page'));

const homeRoute = [
    {
        path: '/',
        name: '首页',
        component: Home,
    },
    {
        path: '/result',
        name: '结果',
        component: Result,
    },
];
export default homeRoute;
